var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAngular(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "70px",
    height: "70px",
    viewBox: "25 -5 70 70",
    enableBackground: "new 25 -5 70 70",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#B52E31",
    points: "36.648,55.712 36.648,45.763 37.947,45.763 44.112,53.775 44.112,45.763 45.345,45.763  45.345,55.712 44.048,55.712 37.875,47.621 37.875,55.712 36.642,55.712  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B52E31",
    d: "M55.39,55.318c-0.841,0.306-1.73,0.461-2.626,0.457c-3.652,0-5.479-1.723-5.479-5.184 c0-3.271,1.762-4.915,5.294-4.915c1.009,0,1.953,0.142,2.817,0.411v1.107c-0.865-0.331-1.761-0.49-2.674-0.49 c-2.755,0-4.133,1.296-4.133,3.856c0,2.765,1.361,4.141,4.068,4.141c0.432,0,0.914-0.063,1.442-0.173v-3.335h1.297v4.126 L55.39,55.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B52E31",
    d: "M57.473,51.872v-6.114h1.296v6.114c0,1.913,0.971,2.868,2.909,2.868c1.922,0,2.909-0.955,2.909-2.868 v-6.114h1.296v6.114c0,2.607-1.396,3.919-4.198,3.919c-2.803,0-4.197-1.312-4.197-3.919H57.473z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B52E31",
    points: "69.487,45.763 69.487,54.683 74.781,54.683 74.781,55.725 68.197,55.725 68.197,45.763  69.494,45.763  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B52E31",
    points: "76.646,55.719 75.286,55.719 80.297,44.458 85.312,55.725 83.871,55.725 82.571,52.598  79.239,52.598 79.592,51.554 82.139,51.554 80.248,47.049 76.645,55.725  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B52E31",
    points: "26.725,55.719 25.363,55.719 30.375,44.458 35.389,55.725 33.948,55.725 32.649,52.598  29.316,52.598 29.669,51.554 32.216,51.554 30.327,47.049 26.722,55.725  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B52E31",
    d: "M86.706,55.719v-9.956h4.308c1.924,0,2.885,0.79,2.885,2.387c0,1.295-0.945,2.259-2.818,2.868l3.46,4.693 h-1.715l-3.204-4.474v-0.821c1.922-0.301,2.908-1.025,2.908-2.196c0-0.916-0.522-1.376-1.602-1.376h-2.883v8.868h-1.33 L86.706,55.719z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E23237",
    d: "M42.847,8.743l16.881-6.019l17.328,5.915l-2.803,22.327L59.728,39l-14.291-7.919L42.847,8.743z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B52E31",
    d: "M77.056,8.638L59.728,2.723V39l14.528-8.035L77.056,8.638L77.056,8.638z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M59.756,6.963L49.232,30.351l3.927-0.079l2.12-5.287h9.397l2.315,5.34l3.743,0.078L59.766,6.95 L59.756,6.963z M59.78,14.475l3.561,7.434h-6.677l3.116-7.432V14.475z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/angular.53deec60ddb8dbe9966b07058ed40b92.svg";
export { ForwardRef as ReactComponent };